import { ABP, eLayoutType } from '@abp/ng.core';

export const BOOKING_BASE_ROUTES: ABP.Route[] = [
  {
    path: '/bookings',
    iconClass: 'fas fa-file-alt',
    name: '::Menu:Bookings',
    layout: eLayoutType.application,
    requiredPolicy: 'Mandir.Bookings',
    breadcrumbText: '::Bookings',
  },
];
